import { ref, computed, nextTick } from 'vue';
import { analyzes } from '../../../src/utils.mjs';

const useComposable = (emits) => {
  const refs = {
    end: ref(),
    date: ref(/* @__PURE__ */ new Date()),
    days: ref([]),
    start: ref(),
    finish: ref(false)
  };
  const nodes = {
    hourser: ref(),
    minuteser: ref(),
    secondser: ref()
  };
  const cDate = computed(() => refs.finish.value ? refs.end.value : refs.start.value);
  const computeds = {
    cSeconds: computed(() => cDate.value ? cDate.value.getSeconds() : -1),
    cMinutes: computed(() => cDate.value ? cDate.value.getMinutes() : -1),
    cHours: computed(() => cDate.value ? cDate.value.getHours() : -1),
    cTime: computed(() => {
      if (!cDate.value) return "";
      else {
        const cHours = cDate.value.getHours().toString().padStart(2, "0");
        const cMinutes = cDate.value.getMinutes().toString().padStart(2, "0");
        const cSeconds = cDate.value.getSeconds().toString().padStart(2, "0");
        return `${cHours}:${cMinutes}:${cSeconds}`;
      }
    })
  };
  const methods = {
    //* 更新函数
    date: (data) => emits("update", data),
    //* 初始化函数
    init: (data) => {
      var _a;
      refs.end.value = analyzes.date(data.end);
      refs.start.value = analyzes.date(data.start);
      methods.update(data.date);
      methods.get_time_site();
      if (data.event) {
        const node = (_a = data.event) == null ? void 0 : _a.target;
        const name = node == null ? void 0 : node.getAttribute("aria-name");
        if (name == "start") refs.finish.value = false;
        else if (name == "end") refs.finish.value = true;
        else {
          const size = (node == null ? void 0 : node.offsetWidth) || 0;
          if (data.event.offsetX > size / 2) refs.finish.value = true;
          else {
            refs.finish.value = false;
          }
        }
        if (refs.finish.value && refs.end.value) emits("update", { year: refs.end.value.getFullYear(), month: refs.end.value.getMonth() });
        else if (!refs.finish.value && refs.start.value) {
          emits("update", { year: refs.start.value.getFullYear(), month: refs.start.value.getMonth() });
        }
      }
    },
    //* 状态更新
    update: (date) => {
      refs.days.value = [];
      refs.date.value = date;
      const d = analyzes.get_month_start_date(refs.date.value);
      for (let i = 0; i < 42; i++) {
        const current = new Date(d.getFullYear(), d.getMonth(), d.getDate() + i);
        refs.days.value.push({
          day: current.getDate(),
          date: analyzes.string("date", current),
          year: current.getFullYear(),
          month: current.getMonth()
        });
      }
    },
    //* 选择函数
    select: (data) => {
      const simulation = {};
      if (refs.finish.value) {
        simulation.main = refs.end.value && new Date(refs.end.value);
        simulation.vice = refs.start.value && new Date(refs.start.value);
      } else {
        simulation.main = refs.start.value && new Date(refs.start.value);
        simulation.vice = refs.end.value && new Date(refs.end.value);
      }
      if (data.date) {
        if (!simulation.main) simulation.main = new Date(data.date.year, data.date.month, data.date.day);
        else {
          simulation.main.setFullYear(data.date.year);
          simulation.main.setMonth(data.date.month);
          simulation.main.setDate(data.date.day);
        }
      } else {
        if (!simulation.main) {
          simulation.main = /* @__PURE__ */ new Date();
          simulation.main.setHours(0);
          simulation.main.setMinutes(0);
          simulation.main.setSeconds(0);
        }
        if (data.hours != void 0) simulation.main.setHours(data.hours);
        if (data.minutes != void 0) simulation.main.setMinutes(data.minutes);
        if (data.seconds != void 0) {
          simulation.main.setSeconds(data.seconds);
        }
      }
      const result = analyzes.get_correct_date({ start: simulation.main, end: simulation.vice });
      refs.finish.value = result.end == simulation.main;
      refs.start.value = result.start;
      refs.end.value = result.end;
      methods.get_time_site();
      emits("message", result);
    },
    //* 确认函数
    confirm: () => {
      emits("change", { start: refs.start.value, end: refs.end.value });
      if (refs.start.value && !refs.end.value) {
        refs.finish.value = true;
      } else if (refs.end.value && !refs.start.value) {
        refs.finish.value = false;
      }
    },
    //* 获取时间位置
    get_time_site: () => {
      nextTick(() => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _i;
        const nHours = (_a = nodes.hourser.value) == null ? void 0 : _a.$el.querySelector(".ui-candidate.ui-active");
        const nMinutes = (_b = nodes.minuteser.value) == null ? void 0 : _b.$el.querySelector(".ui-candidate.ui-active");
        const nSeconds = (_c = nodes.secondser.value) == null ? void 0 : _c.$el.querySelector(".ui-candidate.ui-active");
        if (!nHours) (_d = nodes.hourser.value) == null ? void 0 : _d.move(0);
        else {
          (_e = nodes.hourser.value) == null ? void 0 : _e.move(nHours.offsetTop - 4);
        }
        if (!nMinutes) (_f = nodes.minuteser.value) == null ? void 0 : _f.move(0);
        else {
          (_g = nodes.minuteser.value) == null ? void 0 : _g.move(nMinutes.offsetTop - 4);
        }
        if (!nSeconds) (_h = nodes.secondser.value) == null ? void 0 : _h.move(0);
        else {
          (_i = nodes.secondser.value) == null ? void 0 : _i.move(nSeconds.offsetTop - 4);
        }
      });
    },
    //* 检测日期状态
    get_day_status: (data) => {
      var _a, _b, _c, _d;
      const result = [];
      if (((_a = refs.date.value) == null ? void 0 : _a.getMonth()) != data.month) {
        result.push("ui-other-status");
      }
      if (((_b = cDate.value) == null ? void 0 : _b.getDate()) == data.day && ((_c = cDate.value) == null ? void 0 : _c.getFullYear()) == data.year && ((_d = cDate.value) == null ? void 0 : _d.getMonth()) == data.month) {
        result.push("ui-active");
      }
      return result.join(" ");
    }
  };
  return { refs, nodes, methods, computeds };
};

export { useComposable };
//# sourceMappingURL=composable.mjs.map
